import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../utils';
import { Text } from '../typography';
export function FormSteps({ steps, getCurrentStep }) {
    const currentStepIndex = getCurrentStep().index;
    return (_jsx("div", { className: "flex gap-4 w-full px-6", children: steps.map(({ label }, key) => {
            const isCurrentStep = key === currentStepIndex;
            const isActiveOrDoneStep = key <= currentStepIndex;
            return (_jsxs("div", { className: cn('transition-all duration-200 flex flex-col', 'md:w-full', isCurrentStep ? 'w-full' : 'w-6', 'h-10'), children: [isCurrentStep && (_jsx(Text, { className: cn('py-1 w-full text-indigo-600 text-left flex flex-col gap-2 text-sm text-nowrap transition-colors duration-300'), children: label })), _jsx("div", { className: cn('h-1.5 rounded-full transition-all duration-200 mt-auto', 'md:w-full', isCurrentStep ? 'w-full' : 'w-6', {
                            'bg-indigo-500': isActiveOrDoneStep,
                            'bg-gray-100': !isActiveOrDoneStep,
                        }) })] }, key));
        }) }));
}
